module.exports = __webpack_public_path__ + "img/dink-living-2.376d9890.jpeg";